/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  HighlightMetricsCard,
  HorizontalDividerVector,
  InfluDetailsChart,
  InfluencerTopPosts,
  InfoCardContainer,
  PopupCard,
  ProfileButtonSelector,
  SectionCard,
  TagChip,
  UnlockForCollaborationCard,
  VerticalDividerVector,
} from "../PublicProfile/Component";
import { FiShare } from "react-icons/fi";
import { FaArrowRight } from "react-icons/fa6";
import { useNavigate, useParams } from "react-router-dom";
import { lazy, useCallback, useEffect, useRef, useState } from "react";
import mixpanel from "mixpanel-browser";
import { useInfluencer } from "@/Providers/Influencer";
import { useGeneralSettings } from "@/Providers/General";
import { useStaticData } from "@/Providers/Data";
import { twMerge } from "tailwind-merge";
import { useCookies } from "react-cookie";
import { Button } from "@/shadcnComponents/ui/button";
import {
  ArrowRight,
  Edit,
  HeartIcon,
  MessageCircle,
  PlusIcon,
  Repeat2,
  TriangleAlert,
} from "lucide-react";
import { LoginPopup } from "../CreatorLandingPage/CreatorLandingPage";
import { cn } from "@/lib/utils";
// import ShinyButton from "@/shadcnComponents/ui/shinny-button";
// import { LiaComments } from "react-icons/lia";
import { IoPeopleOutline } from "react-icons/io5";
import { MdAutoGraph } from "react-icons/md";
import { Separator } from "@radix-ui/react-select";
import { useAuth } from "@/Providers/Auth";
import { useToast } from "@/shadcnComponents/ui/use-toast";
import { ToastAction } from "@/shadcnComponents/ui/toast";
import {
  formatFollowersCount,
  formatNumberWithCommas,
} from "../../../Helpers/format-helper";
import { HiLightBulb } from "react-icons/hi";
// import NotFoundPage from "../PublicProfile/ProfileErrorPage";
const NotFoundPage = lazy(() => import("../PublicProfile/ProfileErrorPage"));
const ShinyButton = lazy(() => import("@/shadcnComponents/ui/shinny-button"));

type UnlockPopupProps = {
  slug: string;
  onClose: () => void;
  title?: string;
  icon?: string;
  body?: string;
  buttonText?: string;
};

const UnlockPopup: React.FC<UnlockPopupProps> = ({
  slug,
  onClose,
  title,
  icon,
  body,
  buttonText,
}) => {
  const [, setCookie] = useCookies();
  const navigate = useNavigate();

  const handleSubmit = async () => {
    mixpanel.track(` ${buttonText} Popup Button clicked`);
    setCookie("unlockCreatorSearch", slug, { maxAge: 86400 });
    navigate("/Brand/DashBoard/UnlockInfluencerSearch");
  };

  return (
    <PopupCard onClose={onClose}>
      <div className="flex flex-col text-center gap-4 text-[#FFF] font-Inter not-italic w-full">
        <div className="text-[32px] font-semibold leading-[normal]">{icon}</div>
        <div className="flex flex-col gap-2">
          <div className="text-[16px] font-semibold leading-[18px]">
            {title}
          </div>
          <div className="text-[#9093AA] text-[12px] font-normal leading-[18px]">
            {body}
          </div>
        </div>
        <div>
          <Button variant="destructive" onClick={() => handleSubmit()}>
            <span className="text-[14px] font-semibold leading-[24px]">
              {buttonText}
            </span>
          </Button>
        </div>
      </div>
    </PopupCard>
  );
};

export type themeColorType = {
  color: string[];
  bg: string[];
  from: string[];
  iconbg: string[];
};

export const themeColor: themeColorType = {
  color: ["#171717", "#0D0D0D", "#181414", "#100F0A", "#0E0E15"],
  bg: [
    "bg-[#171717]",
    "bg-[#0D0D0D]",
    "bg-[#181414]",
    "bg-[#100F0A]",
    "bg-[#0E0E15]",
  ],
  from: [
    "from-[#171717]",
    "from-[#0D0D0D]",
    "from-[#181414]",
    "from-[#100F0A]",
    "from-[#0E0E15]",
  ],
  iconbg: [
    "bg-[#3e1a1a]",
    "bg-[#3d371b]",
    "bg-[#403e40]",
    "bg-[#182330]",
    "bg-[#210b43]",
  ],
};

export const InfluencerTemporaryProfile: React.FC = () => {
  // Hooks ----------
  const { slug } = useParams();
  const influencerState = useInfluencer();
  const generalState = useGeneralSettings();
  const staticDataState = useStaticData();
  const authState = useAuth();
  const navigate = useNavigate();
  const targetRef = useRef(null);
  const targetRef2 = useRef(null);
  const { toast } = useToast();

  // States --------------
  const [InfluData, setInfluData] = useState<any>({});

  const [TempInfluData, setTempInfluData] = useState<{
    avgLikes: number;
    avgComments: number;
    avgEngagement: number;
    avgEngagementPercent: any;
    avgReposts: number;
    followers: number;
    topThreeEngagedPosts: [];
    name: string;
    gender: string;
    tagline: string;
    location: string;
    profile_image: string;
    experience: string;
    badge: string;
    featured: [];
    profile_url: string;
    firstThirtyLikes: number[];
    firstThirtyComments: number[];
  }>();
  const [influContentCategory, SetInfluContentCategory] = useState<string[]>();
  const [openUnlockPopup, setOpenUnlockPopup] = useState(false);
  const [openCollabPopup, setOpenCollabPopup] = useState(false);
  const [isVisibleFloater, setIsVisibleFloater] = useState(false); // for floater visibility
  const [themeColorState, setThemeColorState] = useState({
    bgColorClass: "",
    gradientColorFromClass: "",
    IconBgClass: "",
  });
  const [openLoginPopup, setOpenLoginPopup] = useState(false);
  const [showLoginSucces, setShowLoginSuccess] = useState(false);
  const [showErrorPage, setShowErrorPage] = useState(false);

  //master data
  const [masterContentCategory, setMasterContentCategory] = useState([]);
  // const [masterAudienceTypes, setMasterAudienceTypes] = useState([]);

  useEffect(() => {
    staticDataState?.getNewDataFromType("Content Type").then((e) => {
      setMasterContentCategory(e);
    });
    // staticDataState?.getNewDataFromType("Audience Category").then((e) => {
    //   setMasterAudienceTypes(e);
    // });
  }, []);

  // Effects  ---------------------------

  // Dynamic Theme Color
  useEffect(() => {
    const randomColor = (listOfColor: themeColorType) => {
      const index = Math.floor(Math.random() * listOfColor?.bg?.length);
      return [
        listOfColor?.bg[index],
        listOfColor?.from[index],
        listOfColor?.iconbg[index],
      ];
    };

    if (themeColor) {
      const indx = randomColor(themeColor);

      setThemeColorState({
        bgColorClass: indx[0],
        gradientColorFromClass: indx[1],
        IconBgClass: indx[2],
      });
    }
  }, []);

  // Get Influencer Data
  useEffect(() => {
    mixpanel.track("Visted Profile Page Collab");
    generalState.setLoading(true);
    if (authState?.loggedUser) {
      const getPersonalData = async () => {
        generalState.setLoading(false);
        await influencerState
          .getPersonalInfo()
          .then((resData) => {
            if (resData.success) {
              setInfluData((prev) => ({
                ...prev,
                profileData: resData?.data,
                collabHistory: resData?.data2?.data,
                monetizationChannels: resData?.data3?.data,
                contentCategories: resData?.data4?.categories,
                contentFormat: resData?.data4?.formats,
                audiencePlatform: resData?.data5?.platforms,
                audienceTypes: resData?.data5?.types,
                topLinks: resData?.data5?.topLinks,
              }));
            }
          })
          .finally(() => generalState.setLoading(false));
      };
      getPersonalData();
    }

    const getTempInfluencerData = async () => {
      await influencerState
        .getTempInfluencerLinkedinProfileFromSlug(slug)
        .then((resData) => {
          if (resData.success) {
            // if (!resData?.LinkedinAnalysis?.name) {
            //   generalState.setLoading(false);
            //   return navigate("/influencer/dashboard");
            // }
            setTempInfluData(resData?.LinkedinAnalysis);
            SetInfluContentCategory(resData?.ContentCategory);
            generalState.setLoading(false);
          } else {
            generalState?.setLoading(false);
            setShowErrorPage(true);
          }
        })
        .catch(() => {
          generalState?.setLoading(false);
          setShowErrorPage(true);
        });
    };
    getTempInfluencerData();
  }, [slug, authState]);

  // Floating Button
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;

      // Adjust this value based on the client height where you want to show the component
      const triggerHeight = targetRef?.current?.clientHeight;
      const triggerHeight2 = targetRef2?.current?.clientHeight;

      // console.log("scroll: ", scrollY, "target-Creator Profile:", triggerHeight, "target2-Creator Data Section:", triggerHeight2);

      // Check if the scroll position has crossed the trigger height
      setIsVisibleFloater(scrollY > triggerHeight);

      if (scrollY > triggerHeight2) {
        setIsVisibleFloater(false);
      }
    };

    // Attach the event listener when the component mounts
    window.addEventListener("scroll", handleScroll);

    // Detach the event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Run the effect only once when the component mounts

  // handler function ---------------------------

  // Share Profile
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: `anchors|collab`,
          text: `${TempInfluData?.name} is open for collaboration`,
          url: window.location.href,
        });
      } catch (error) {
        console.error("Something went wrong while sharing", error);
      }
    } else {
      console.log("Web Share API is not supported in your browser.");
    }
  };

  const checkLoginStatus = useCallback(() => {
    return (
      localStorage.getItem("jwtToken") &&
      localStorage.getItem("UserType") === "Influencer"
    );
  }, []);
  const checkCurrentUser = () => {
    return slug === authState?.loggedUser?.slug;
  };
  useEffect(() => {
    if (localStorage.getItem("Login_from_temp") === "true") {
      setShowLoginSuccess(true);
      localStorage.removeItem("Login_from_temp");
    }
  }, [toast]);
  useEffect(() => {
    if (showLoginSucces) {
      toast({
        title: "Logged In Successfully",
        className: "bg-green-600 text-white",
      });
    }
  }, [showLoginSucces]);

  return (
    <>
      {openUnlockPopup && (
        <UnlockPopup
          slug={slug}
          onClose={() => {
            mixpanel.track("Unlock popup closed");
            setOpenUnlockPopup(false);
          }}
          icon="🔒"
          title="Contact Info Locked!"
          body="This information is not publicly available.
                      Please proceed to unlock it if you'd like to connect with the creator directly."
          buttonText="🫱🏼‍🫲🏽 Unlock Now"
        />
      )}

      {openCollabPopup && (
        <UnlockPopup
          slug={slug}
          onClose={() => {
            mixpanel.track("Collab popup closed");
            setOpenCollabPopup(false);
          }}
          title="Ready to Partner?"
          body={`Connect with ${TempInfluData?.name} directly and bring your brand vision to life together. Unlock the contact details and start collaborating :)`}
          buttonText="🫱🏼‍🫲🏽 Connect Now!"
        />
      )}

      {openLoginPopup && (
        <LoginPopup onClose={() => setOpenLoginPopup(false)} backToSource />
      )}

      {showErrorPage ? (
        <NotFoundPage />
      ) : (
        <div
          className={twMerge(
            `text-white min-h-svh bg-[#171717] md:px-[96px] md:py-[30px] relative`,
            `${themeColorState.bgColorClass}`
          )}
        >
          {/* floating button - create your profile for desktop */}
          <div className="hidden md:block fixed bottom-0 right-0 p-4 z-20">
            <div className="flex items-center gap-[12px]">
              <div className="felx items-center justify-center animate-border inline-block rounded-[8px] bg-white bg-gradient-to-r from-red-500 via-purple-500 to-blue-500 bg-[length:400%_400%] p-[2px]">
                <ShinyButton
                  className="flex px-[12px] py-[8px] justify-center items-center gap-[4.75px] self-stretch rounded-[6px] border-[1px] border-solid  text-[#FFF] text-center font-[Inter] not-italic leading-[normal] bg-black"
                  onClick={() => {
                    mixpanel.track("Create your Collab Profile : Temp Profile");
                    const url = `/influencer?ref=collabTempProfile`;
                    window.open(url, "_blank");
                  }}
                >
                  <span className="text-[16px] font-normal">🪄</span>
                  <span className="text-[12px] font-semibold">
                    Create your Collab Profile
                  </span>
                </ShinyButton>
              </div>
            </div>
          </div>

          {/* main */}
          <div className="md:flex md:gap-[28px] w-full h-max">
            {/* Creator Profile */}
            <section
              ref={targetRef}
              className="md:w-[365px] shrink-0  md:flex md:flex-col md:gap-[28px]"
            >
              <div className="md:p-[16px] md:rounded-[8px] md:border-[1px] md:border-solid md:border-[#262626]">
                <div className="relative h-[359px]">
                  <img
                    src={
                      TempInfluData?.profile_image ||
                      InfluData?.profileData?.profile ||
                      "https://collab.anchors.in/FeatredCreatorBackground.png"
                    }
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src =
                        "https://collab.anchors.in/FeatredCreatorBackground.png";
                    }}
                    alt={`${
                      TempInfluData?.name || InfluData?.profileData?.name
                    } Pic`}
                    className="z-[1] object-cover h-full w-full md:rounded-[8px]"
                  />
                  <div
                    className={twMerge(
                      `z-[2] absolute top-0 left-0 right-0 bottom-0 bg-gradient-to-t from-[#171717] to-transparent`,
                      `${themeColorState.gradientColorFromClass}`
                    )}
                  >
                    <div className="flex flex-col justify-between w-full h-full">
                      <div></div>
                      <span className="w-full text-center text-white text-[40px] not-italic font-bold leading-[normal] font-[Inter] px-[16px]">
                        {TempInfluData?.name || InfluData?.profileData?.name}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="px-[16px]">
                  {/* {TempInfluData?.badge && (
                  <div className="mt-[16px] flex justify-center">
                    <div className="flex justify-center items-center gap-2 px-3 py-1.5 rounded bg-[linear-gradient(92deg,_rgba(241,_241,_241,_0.16)_1.57%,_rgba(243,_171,_171,_0.00)_49.29%,_rgba(241,_241,_241,_0.20)_96.06%)]">
                      <div className="w-6 h-6">
                        <img
                          src={featureLogo}
                          alt="logo"
                          className="w-full h-full"
                        />
                      </div>
                      <span className="rounded text-white text-center text-xs not-italic font-bold leading-[normal] font-[Inter]">
                        {TempInfluData?.badge}
                      </span>
                    </div>
                  </div>
                )} */}

                  <div className="mt-[16px] mb-[32px] flex flex-col items-center gap-4">
                    {/* feature tag */}

                    {TempInfluData?.badge && (
                      <div className="rounded-full bg-[#38434FFC] px-3 py-[6px] text-[12px] font-inter font-semibold flex gap-2">
                        <HiLightBulb size={16} color="#F1F1F1" />
                        {TempInfluData?.badge}
                      </div>
                    )}

                    {TempInfluData?.tagline && (
                      <div className="text-[#D9D9D9] line-clamp-2 text-center text-sm not-italic font-normal leading-6 tracking-[0.14px] self-stretch">
                        {TempInfluData?.tagline}
                      </div>
                    )}

                    {TempInfluData?.location && (
                      <div className="text-[#D9D9D9] line-clamp-2 text-center text-sm not-italic font-normal leading-6 tracking-[0.14px] self-stretch">
                        📍{TempInfluData?.location}
                      </div>
                    )}

                    {/* Social Links */}
                    <div
                      className="w-full flex justify-center  items-center overflow-x-auto"
                      style={{ scrollbarWidth: "none" }}
                    >
                      <div className="w-fit flex justify-center gap-3 flex-wrap">
                        <ProfileButtonSelector
                          profileData={{
                            linkedinLink: TempInfluData?.profile_url,
                          }}
                          color={themeColorState.IconBgClass}
                        />
                      </div>
                    </div>

                    {/* Follow button */}
                    {
                      <div className="flex flex-col items-center gap-4">
                        <Button
                          className={`group/follow-btn text-[#ffff] font-bold font-[Inter] text-[12px] not-italic leading-[normal] w-full gap-2 bg-transparent border border-[#F1F1F1] hover:bg-[#F1F1F1] hover:text-[#171717] hover:border-[#F1F1F1] py-[8px] px-[16px] rounded-full `}
                          variant="outline"
                          size="sm"
                        >
                          {
                            <>
                              <PlusIcon size={16} /> Follow
                            </>
                          }
                        </Button>
                      </div>
                    }
                  </div>

                  {/* CTA Button --- Under Profile */}
                  <div
                    className={twMerge(
                      `flex items-start gap-[16px]`,
                      `${themeColorState.bgColorClass}`
                    )}
                  >
                    <button
                      className="flex px-[16px] py-[8px] justify-center items-center gap-[10px] self-stretch rounded-[6px] bg-[#E2E8F0]"
                      onClick={() => {
                        mixpanel.track("share profile");
                        handleShare();
                      }}
                    >
                      <FiShare size={20} color="#000000" />
                    </button>

                    {/* collaborate with me button */}
                    <button
                      className="flex px-[16px] py-[8px] justify-center items-center gap-[10px] flex-[1_0_0] rounded-[6px] bg-[#DC2627]"
                      onClick={() => {
                        mixpanel.track("Collaborate with me");
                      }}
                    >
                      <span className="text-[#FFF] text-[14px] not-italic font-medium leading-[24px] font-[Inter]">
                        Collaborate with me
                      </span>
                      <FaArrowRight size={16} color="#FFF" />
                    </button>
                  </div>
                </div>
              </div>

              {/* Unlock for collaboration! - desktop */}
              <section className="hidden md:block">
                <UnlockForCollaborationCard
                  onUnlockClick={() => {
                    mixpanel.track("Unlock button click : Temp Profile");
                  }}
                  onCollabClick={() => setOpenCollabPopup(false)}
                />
              </section>
            </section>

            {/* Vertical Divider */}
            <div className="md:hidden">
              <VerticalDividerVector />
            </div>

            {/* Creator Data Section*/}
            <section ref={targetRef2} className="px-[16px] md:px-0 w-full">
              {/* Top links ---------------------- */}
              {/* {TempInfluData?.topLinks?.length > 0 && (
              <>
                <div>
                  <SectionCard
                    icon={"📌"}
                    title="My Top Links"
                    subtitle="Links to my top social media profiles & websites"
                  >
                    <div className="flex items-start flex-wrap gap-4">
                      {TempInfluData?.topLinks?.map((item, index) => {
                        return (
                          <div
                            key={index}
                            className="bg-white md:w-fit w-full group rounded-[8px] border-[1px] border-solid border-[#262626] hover:border-[#DC2627] p-[1rem] md:py-[0.75rem] md:px-[1rem] flex justify-between gap-5 items-center cursor-pointer"
                            onClick={() => {
                              mixpanel.track("Top Link Clicked", {
                                link: item?.link,
                                position: index + 1,
                              });
                              window.open(item?.link, "_blank");
                            }}
                          >
                            <div className="flex gap-2 items-center">
                              <div className="rounded-full shrink-0">
                                {item?.icon && (
                                  <img
                                    src={`${host}/api/file/proxyImage?imageUrl=${encodeURIComponent(
                                      item?.icon
                                    )}`}
                                    onError={({ currentTarget }) => {
                                      currentTarget.onerror = null; // prevents looping
                                      currentTarget.src =
                                        "https://cdn-icons-png.flaticon.com/512/5339/5339181.png";
                                    }}
                                    alt=""
                                    className="object-cover size-[26px] "
                                  />
                                )}
                              </div>
                              <span className="text-black font-medium">
                                {item.linkText}
                              </span>
                            </div>
                            <SquareArrowOutUpRight
                              size={16}
                              className="text-black p-0 group-hover:text-[#DC2627] bg-transparent"
                            />
                          </div>
                        );
                      })}
                    </div>
                  </SectionCard>
                </div>
                <VerticalDividerVector />
              </>
            )} */}

              {/* -------- temporary media kit warning / edit / publish --------------*/}
              <InfoCardContainer
                icon={<TriangleAlert size={20} color="#DC2627" />}
                title={"Temporary Media Kit"}
                description={
                  "Claim and customize this media kit to showcase your unique"
                }
                actionArea={
                  <EditAndPublish
                    onEdit={() => {
                      if (!checkLoginStatus()) {
                        mixpanel.track(
                          "Temp Profile: Edit Button Clicked without login"
                        );
                        setOpenLoginPopup(true);
                        return;
                      } else {
                        if (checkCurrentUser()) {
                          mixpanel.track(
                            "Temp Profile: Edit Button Clicked with login"
                          );
                          navigate("/influencer/dashboard");
                        } else {
                          return toast({
                            title: "You can edit only your profile",
                            action: (
                              <ToastAction
                                className="bg-red-500 text-white hover:bg-red-400 "
                                onClick={() => {
                                  mixpanel?.track(
                                    "Open my Profile clicked : Temp Profile"
                                  );
                                  navigate(`/t/${authState?.loggedUser?.slug}`);
                                }}
                                altText="Open my profile"
                              >
                                Open my profile
                              </ToastAction>
                            ),
                          });
                        }
                      }
                    }}
                    onPublish={() => {
                      if (!checkLoginStatus()) {
                        mixpanel.track(
                          "Temp Profile: Publish Button Clicked without login"
                        );
                        setOpenLoginPopup(true);
                        return;
                      } else {
                        if (checkCurrentUser()) {
                          navigate("/influencer/payment");
                        } else {
                          return toast({
                            title: "You can publish only your profile",
                            action: (
                              <ToastAction
                                className="bg-red-500 text-white hover:bg-red-400 "
                                onClick={() => {
                                  mixpanel?.track(
                                    "Open my Profile clicked : Temp Profile"
                                  );
                                  navigate(`/t/${authState?.loggedUser?.slug}`);
                                }}
                                altText="Open my profile"
                              >
                                Open my profile
                              </ToastAction>
                            ),
                          });
                        }
                      }
                    }}
                  />
                }
              />
              <Separator className="h-3" />

              {/* ----------------------- Profile Highlights ------------------------- */}
              {TempInfluData && (
                <>
                  <div className="">
                    <SectionCard
                      icon={"🫱🏼‍🫲🏽"}
                      title="Profile Highlights"
                      subtitle="A quick glance at some key stats"
                    >
                      <div className="w-full grid grid-cols-2 md:grid-cols-5 items-start flex-wrap gap-[15px]">
                        {[
                          {
                            icon: <IoPeopleOutline color="#568CDD" size={25} />,
                            title: "Total Followers",
                            value:
                              TempInfluData?.followers?.toString()?.length > 7
                                ? formatFollowersCount(TempInfluData?.followers)
                                : formatNumberWithCommas({
                                    num: TempInfluData?.followers || 0,
                                  }) || 0,
                          },
                          {
                            icon: <HeartIcon color="#DC2627" size={25} />,
                            title: "Avg Likes",
                            value: TempInfluData?.avgLikes
                              ? Math.ceil(TempInfluData?.avgLikes)
                              : 0,
                          },
                          {
                            icon: <MessageCircle color="#1070E0" size={25} />,
                            title: "Avg Comments",
                            value: TempInfluData?.avgComments
                              ? Math.ceil(TempInfluData?.avgComments)
                              : 0,
                          },
                          {
                            icon: <Repeat2 color="#13931D" size={25} />,
                            title: "Avg Reposts",
                            value: TempInfluData?.avgReposts
                              ? Math.ceil(TempInfluData?.avgReposts)
                              : 0,
                          },
                          {
                            icon: <MdAutoGraph color="#F59E00" size={25} />,
                            title: "Avg Eng.",
                            value: `${
                              TempInfluData?.avgEngagementPercent
                                ? `${
                                    Math.ceil(
                                      TempInfluData?.avgEngagementPercent * 10
                                    ) / 10
                                  }%`
                                : 0
                            }`,
                          },
                        ].map((item, i) => {
                          if (!item?.value || parseFloat(item?.value) <= 0)
                            return null;
                          return (
                            <HighlightMetricsCard
                              key={i}
                              icon={item?.icon}
                              value={item?.value}
                              title={item?.title}
                            />
                          );
                        })}
                      </div>
                    </SectionCard>
                  </div>
                </>
              )}

              {/* Post Wise Engagement..... */}
              {(TempInfluData?.firstThirtyLikes?.length > 0 ||
                TempInfluData?.firstThirtyComments?.length > 0) && (
                <>
                  <VerticalDividerVector />
                  <InfluDetailsChart
                    firstThirtyComments={TempInfluData?.firstThirtyComments}
                    firstThirtyLikes={TempInfluData?.firstThirtyLikes}
                  />
                </>
              )}

              {/* Top engaged posts.......... */}
              {TempInfluData?.topThreeEngagedPosts?.length > 0 && (
                <>
                  <VerticalDividerVector />
                  <InfluencerTopPosts
                    TopPosts={TempInfluData?.topThreeEngagedPosts}
                    influencer={{
                      name: TempInfluData?.name,
                      profile:
                        TempInfluData?.profile_image ||
                        InfluData?.profileData?.profile,
                      tagline: TempInfluData?.tagline,
                    }}
                  />
                </>
              )}

              {/* Content Category/Content Focus --------------------------*/}
              {influContentCategory?.length > 0 && (
                <>
                  <VerticalDividerVector />

                  <div className="">
                    <SectionCard
                      icon={"💭"}
                      title="Content Focus"
                      subtitle="Niche categories & topics I majorly focus on"
                    >
                      <div className="flex items-start gap-[8px] flex-wrap">
                        {influContentCategory
                          ?.slice(0, 6)
                          .map((data, index) => {
                            return (
                              <TagChip
                                key={index}
                                title={
                                  masterContentCategory?.find(
                                    (category) => category?._id === data
                                  )?.categoryName || data
                                }
                              />
                            );
                          })}
                        {influContentCategory?.length > 6 && (
                          <TagChip
                            title={`+${influContentCategory?.length - 6}`}
                          />
                        )}
                      </div>
                    </SectionCard>
                  </div>
                </>
              )}
            </section>
          </div>

          {/* CTA button --- floating Mobile */}
          {isVisibleFloater && (
            <div
              className={cn(
                "z-[5] bottom-0 left-0 right-0 fixed p-4 space-y-4",
                `${themeColorState.bgColorClass}`
              )}
            >
              <div className="flex items-start gap-[16px]">
                <div className="flex justify-between w-full">
                  <EditAndPublish
                    onEdit={() => {
                      if (!checkLoginStatus()) {
                        mixpanel.track(
                          "Temp Profile: Edit Button Clicked without login"
                        );
                        setOpenLoginPopup(true);
                        return;
                      } else {
                        if (checkCurrentUser()) {
                          mixpanel.track(
                            "Temp Profile: Edit Button Clicked with login"
                          );
                          navigate("/influencer/dashboard");
                        } else {
                          return toast({
                            title: "You can edit only your profile",
                            action: (
                              <ToastAction
                                className="bg-red-500 text-white hover:bg-red-400 "
                                onClick={() => {
                                  mixpanel?.track(
                                    "Open my Profile clicked : Temp Profile"
                                  );
                                  navigate(`/t/${authState?.loggedUser?.slug}`);
                                }}
                                altText="Open my profile"
                              >
                                Open my profile
                              </ToastAction>
                            ),
                          });
                        }
                      }
                    }}
                    onPublish={() => {
                      if (!checkLoginStatus()) {
                        mixpanel.track(
                          "Temp Profile: Publish Button Clicked without login"
                        );
                        setOpenLoginPopup(true);
                        return;
                      } else {
                        if (checkCurrentUser()) {
                          navigate("/influencer/payment");
                        } else {
                          return toast({
                            title: "You can publish only your profile",
                            action: (
                              <ToastAction
                                className="bg-red-500 text-white hover:bg-red-400 "
                                onClick={() => {
                                  mixpanel?.track(
                                    "Open my Profile clicked : Temp Profile"
                                  );
                                  navigate(`/t/${authState?.loggedUser?.slug}`);
                                }}
                                altText="Open my profile"
                              >
                                Open my profile
                              </ToastAction>
                            ),
                          });
                        }
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          )}

          {/* Unlock for collaboration! - mobile */}
          <section className="md:hidden">
            <div className="px-[16px] py-[32px]">
              <UnlockForCollaborationCard
                onUnlockClick={() => {
                  mixpanel.track("Unlock button click");
                  setOpenUnlockPopup(false);
                }}
                onCollabClick={() => setOpenCollabPopup(false)}
              />
            </div>
          </section>

          {/* Horizontal Divider */}
          <div className="md:pt-[56px] md:pb-[20px]">
            <HorizontalDividerVector width="w-[174px] md:max-w-[1248px]" />
          </div>

          {/* Footer */}
          <section className="pb-[55px] pt-[20px] flex items-center justify-center md:p-0">
            <div className="flex flex-col justify-center items-center gap-[20px] w-fit md:w-full md:flex-row md:justify-between">
              <div className="text-[rgba(163,_163,_163,_0.67)] text-center font-[Inter] text-[12px] not-italic font-normal leading-[18px]">
                <span>{"Powered by "}</span>
                <a
                  href="http://anchors.in"
                  target="_blank"
                  className="font-bold hover:underline"
                  onClick={() => mixpanel.track("Clicked Powered by Anchors")}
                >
                  anchors.in
                </a>
              </div>

              {/* Button */}
              <div className="md:hidden flex items-center gap-[12px]">
                <span className="text-[#A3A3A3] text-center font-[Inter] text-[14px] not-italic font-normal leading-[18px]">
                  Influencer?
                </span>
                <button
                  className="flex px-[12px] py-[8px] justify-center items-center gap-[4.75px] self-stretch rounded-[6px] border-[1px] border-solid border-[#FFF] text-[#FFF] text-center font-[Inter] not-italic leading-[normal]"
                  onClick={() => {
                    mixpanel.track("Create your Collab Profile : Temp Profile");
                    const url = `/influencer?ref=collabTempProfile`;
                    window.open(url, "_blank");
                  }}
                >
                  <span className="text-[16px] font-normal">🪄</span>
                  <span className="text-[12px] font-semibold">
                    Create your Collab Profile
                  </span>
                </button>
              </div>
            </div>
          </section>
        </div>
      )}
    </>
  );
};

interface EditAndPublishProps {
  onEdit?: () => void;
  onPublish?: () => void;
}

const EditAndPublish: React.FC<EditAndPublishProps> = ({
  onEdit,
  onPublish,
}) => {
  return (
    <>
      <Button variant="secondary" onClick={onEdit}>
        <Edit size={16} className="mr-2" />
        Edit
      </Button>
      <Button variant="destructive" onClick={onPublish}>
        Publish
        <ArrowRight size={16} className="ml-2" />
      </Button>
    </>
  );
};
